import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import { publicSigningRoutes } from '@modules/publicSigning/publicSigningRoute'

// Pre-auth routes mounted under the AuthLayout shell.
//
// Seed set: the error page and the catch-all 404.
// As you build public-facing modules (auth, landing, …), spread their
// published route collections in here — e.g. `...authRoutes`.
//
// The `/` hand-off is NOT here: it lives at the top of `router/index.ts`
// because every layout is mounted on '/', and the first-registered '/' record
// wins the tie — nested here it would be shadowed by a layout.
export const publicRoutes: RouteRecordRaw[] = [
  {
    path: routes.ERROR,
    name: 'ERROR',
    component: () => import('@app/pages/ErrorPage.vue'),
  },
  ...publicSigningRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'NOT_FOUND',
    component: () => import('@app/pages/NotFoundPage.vue'),
  },
]
